// eslint-disable-next-line camelcase
import en_US from "./en_US";
// eslint-disable-next-line camelcase
import de_DE from "./de_DE";

export default {
  en_US,
  de_DE,
};
